import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import { getGenerateWarehouseDocumentRequestsState } from '../../../../../../features/inventory/get_generate_warehouse_document_requests';
import { GenerateWarehouseDocumentTypeRequestEnum } from '../../../../../../core/enums/inventory/warehouse_document';
import { getAllPodsState } from '../../../../../../features/pod/get_all_pods';

const WarehouseDocumentHistoryDetails = ({ documentIndex, type }) => {
    const getWarehouseDocumentHistory = useSelector(getGenerateWarehouseDocumentRequestsState);
    const getAllPods = useSelector(getAllPodsState);

    return (
        <Grid container item>
            <TableContainer>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell>Nazwa produktu</TableCell>
                            <TableCell align="center">Liczba szt.</TableCell>
                            <TableCell align="center">Cena zakupu [netto]</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            type === GenerateWarehouseDocumentTypeRequestEnum.PZ_DOCUMENT.value &&
                            getWarehouseDocumentHistory?.data?.content?.[documentIndex]?.positions?.map((position, index) => (
                                <TableRow
                                    key={ index + position?.productId }
                                    hover
                                >
                                    <TableCell>{ position?.productName }</TableCell>
                                    <TableCell align="center">{ position?.quantity }</TableCell>
                                    <TableCell align="center">{ position?.purchaseNetPrice?.toFixed(2) }</TableCell>
                                </TableRow>
                            ))
                        }
                        {
                            (getAllPods?.data && type === GenerateWarehouseDocumentTypeRequestEnum.PZ_AND_MM_DOCUMENTS.value) &&
                            Object.keys(getWarehouseDocumentHistory?.data?.content?.[documentIndex]?.positions)?.map((key, index) => (
                                <Fragment key={ index }>
                                    <TableRow
                                        key={ key }
                                        hover
                                    >
                                        <TableCell colSpan={ 3 } align="center">
                                            {
                                                getAllPods?.data?.map(pod => ({
                                                    id: pod?.id,
                                                    label: pod?.indoorPartner?.name + ' (' + pod?.description + ') - ' + (pod?.device?.serviceId || 'brak urządzenia')
                                                }))
                                                    .find(pod => pod?.id === key)?.label
                                            }
                                        </TableCell>
                                    </TableRow>
                                    {
                                        getWarehouseDocumentHistory?.data?.content?.[documentIndex]?.positions?.[key]?.map((position, index) => (
                                            <TableRow
                                                key={ index + key }
                                                hover
                                            >
                                                <TableCell>{ position?.productName }</TableCell>
                                                <TableCell align="center">{ position?.quantity }</TableCell>
                                                <TableCell
                                                    align="center">{ position?.purchaseNetPrice?.toFixed(2) }</TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </Fragment>
                            ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    );
};

export default WarehouseDocumentHistoryDetails;
